import './index.scss';
import React, { useState, useEffect } from 'react';
import manager from '../../Manager';
import {
    TemplateIconAudio,
    TemplateIconDocument, TemplateIconImage, TemplateIconMultipleChoice, TemplateIconText, TemplateIconVideo
} from '../../icons/svgs';

function ModalNewSlide({ addSlide, updateSlide, actionUpdateTemplate, selectedSlide, setSelectedSlide, isMobileBuilder=false }) {
    const [selectedIndex, setSelectedIndex] = useState(0);
    useEffect(() => {
        if (selectedSlide) {
            let templateIndexExiting = manager.templateManager.templates.indexOf(selectedSlide.template);
            if (templateIndexExiting >= 0) {
                setSelectedIndex(templateIndexExiting);
            }
        }
    }, [selectedSlide]);

    const useTemplate = () => {
        const selectedTemplate = manager.templateManager.templates[selectedIndex];
        if (!actionUpdateTemplate) {
            addSlide(selectedTemplate);
        } else {
            updateSlide(selectedTemplate);
        }
        window.jQuery('#tbcourse-modal-new-slide').modal('hide');
    }

    const templateIcons = {
        document: <TemplateIconDocument />,
        image: <TemplateIconImage />,
        multiplechoice: <TemplateIconMultipleChoice />,
        text: <TemplateIconText />,
        video: <TemplateIconVideo />,
        audio: <TemplateIconAudio />
    };

    const textHighlight = manager.templateManager.templates[selectedIndex].textHighlight();

    return (

        <div className={`tbcourse-modal tbcourse-modal-new-slide modal ${isMobileBuilder ? 'modal-mobile-builder':''}`} id="tbcourse-modal-new-slide" tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header border-0">
                        <h5 className={`modal-title ${isMobileBuilder ? 'font-size-20' : 'font-size-28'}`}>Select Slide Template</h5>
                        {/* <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">
                            <IconCross/>
                        </span>
                    </button> */}
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className={`modal-body font-family-inter ${isMobileBuilder ? 'font-size-12' : 'font-size-14 '}`}>
                        <p>You can choose a template to make your life easier and your slide on point, please choose wisely depend on your content.</p>
                        <div className="tbcourse-slide-items">
                            {manager.templateManager.templates.map((item, index) => (
                                <div className={`tbcourse-slide-item cursor-pointer ` + (selectedIndex === index ? 'selected' : '')} key={index} onClick={() => setSelectedIndex(index)}>
                                    <div className="tbcourse-slide-item-header">
                                        <span className="tbcourse-sidebar-items-icon">
                                            {templateIcons[item.iconType()]}
                                        </span>
                                        <span className="tbcourse-slide-item-name text-uppercase">{item.name()}</span>
                                    </div>
                                    <div className="tbcourse-slide-item-body">
                                        {item.imageTemplate()}

                                        {/* <ReactSVG src={templateImages[item.iconType()]} wrapper='span'/> */}
                                        {/* <div className="tbcourse-slide-item-name">{item.name()}</div> */}
                                    </div>
                                </div>

                            ))}
                        </div>
                        {textHighlight}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-primary" onClick={useTemplate}>Use Template</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ModalNewSlide;
